
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function BeforeAfter() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  // SEO対策のためのmeta情報を動的に設定
  useEffect(() => {
    // ページタイトルを設定
    document.title = '壁紙張替え・クロス交換不要の施工事例一覧 | 壁紙革命浦和 - 退去費用を約半額に削減';
    
    // meta descriptionを設定
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        '壁紙張替え・クロス交換不要のクロスメイク施工事例一覧。ヤニ汚れ、カビ、手垢など様々な汚れを壁紙交換せずに新品同様に再生。退去費用を約半額に削減する革新的なクロス工事の実績をご覧ください。'
      );
    }

    // キーワードを設定
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 
        '壁紙張替え,クロス交換,壁紙交換,クロス部分張替え,クロス汚れ,退去費用,クロス張替え,クロス工事,壁紙リメイク,原状回復,賃貸物件,施工事例'
      );
    }

    return () => {
      // クリーンアップ時に元のタイトルに戻す
      document.title = '壁紙革命浦和 - 壁紙張替え・クロス交換不要！賃貸物件オーナー様の味方。壁紙を張り替えずに新品同様に再生します';
    };
  }, []);

  const caseStudies = [
    {
      id: 1,
      category: 'ヤニ汚れ',
      title: 'タバコのヤニで黄ばんだ壁紙の再生',
      location: 'さいたま市浦和区 1K アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/b73da1dfaaf3884917b520b664ddb1c6.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/32dbd8c94356c3b6fe38f58b02ba28dc.jfif',
      description: '長年のタバコのヤニで黄色く変色した壁紙を、クロスメイクで真っ白に再生。臭いも完全に除去されました。',
      workTime: '2時間30分',
      cost: '28,000円',
      area: '18㎡'
    },
    {
      id: 2,
      category: 'ヤニ汚れ',
      title: '重度のヤニ汚れもダブルコーティングで対応',
      location: 'さいたま市見沼区 1K アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/42ff4b4ccb41e02a533777ccd71db5c6.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/479c0830b41cbd6cf814b5b22dd76158.jfif',
      description: '10年以上のヘビースモーカーによる重度のヤニ汚れも、ダブルコーティング技術で完全に白く再生しました。',
      workTime: '3時間30分',
      cost: '38,000円',
      area: '20㎡'
    },
    {
      id: 3,
      category: 'ヤニ汚れ',
      title: 'ワンルームのヤニ汚れ完全除去',
      location: 'さいたま市緑区 1R アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/f914c8aff93c23446a16812ed9c7ed23.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/6418748284d5b8f9d734e876c571fd86.jfif',
      description: '5年間のヘビースモーカーが住んでいたワンルームのヤニ汚れを、特殊洗浄とクロスメイクで新品同様に再生。',
      workTime: '2時間45分',
      cost: '26,000円',
      area: '16㎡'
    },
    {
      id: 4,
      category: 'カビ汚れ',
      title: '湿気によるカビ汚れの完全除去',
      location: 'さいたま市南区 1DK マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/7f682debfceb0eeee340d1f2d53d7700.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/e988cfed0a06c95d389add44e7c4f709.jfif',
      description: '浴室近くの湿気でカビが発生した壁紙を、抗菌・防カビ効果のあるクロスメイクで清潔に再生しました。',
      workTime: '3時間',
      cost: '35,000円',
      area: '25㎡'
    },
    {
      id: 5,
      category: 'カビ汚れ',
      title: '北側部屋の黒カビ除去',
      location: 'さいたま市西区 1K マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/83ccc35d4edeca16fae99a7a186c68db.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/c8e53857b274e4665a01074b2c2ec01d.jfif',
      description: '日当たりの悪い北側部屋に発生した黒カビを、専用の除菌処理とクロスメイクで完全に除去し、防カビ効果も付与。',
      workTime: '2時間30分',
      cost: '29,000円',
      area: '19㎡'
    },
    {
      id: 6,
      category: 'カビ汚れ',
      title: '結露によるカビ汚れの再生',
      location: 'さいたま市中央区 1DK アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/53f15e639f524919ffb61fdcfb4a42ee.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/72d69dad60f6c78c3c31a260b539edde.jfif',
      description: '冬場の結露で発生したカビ汚れを、根本的な除菌処理とクロスメイクで清潔に再生。再発防止効果も実現。',
      workTime: '3時間15分',
      cost: '33,000円',
      area: '23㎡'
    },
    {
      id: 7,
      category: '換気扇・換気口',
      title: '換気扇周りの油汚れとホコリの除去',
      location: 'さいたま市大宮区 1R アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/0c0b3690a7315279fb66c272f710923b.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/40b7e1838f92ad4641fc8ac9573f91a8.jfif',
      description: 'キッチンの換気扇周りに付着した調理油とホコリによる黒ずみを、短時間で真っ白に再生しました。',
      workTime: '2時間',
      cost: '25,000円',
      area: '15㎡'
    },
    {
      id: 8,
      category: '換気扇・換気口',
      title: 'トイレ換気扇周りの汚れ除去',
      location: 'さいたま市桜区 1K アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/015e8e610d79d7be10f6a74e785ac523.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/be0608289c0e26546586704651cac96b.jfif',
      description: 'トイレの換気扇周りに蓄積した湿気とホコリによる汚れを、専用洗浄とクロスメイクで清潔に再生。',
      workTime: '1時間45分',
      cost: '22,000円',
      area: '12㎡'
    },
    {
      id: 9,
      category: '換気扇・換気口',
      title: '浴室換気扇周りの黒ずみ除去',
      location: 'さいたま市岩槻区 1DK マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/c50ae2ef9baeab7e1fe15d6329943eec.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/843170201ebb433e085f0dd9b65b29e9.jfif',
      description: '浴室の換気扇周りに発生した湿気による黒ずみを、防カビ処理とクロスメイクで完全に除去し、清潔な状態に。',
      workTime: '2時間15分',
      cost: '27,000円',
      area: '17㎡'
    },
    {
      id: 10,
      category: '冷蔵庫裏',
      title: '家具裏の隠れた汚れもきれいに',
      location: 'さいたま市中央区 1LDK マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/1caa93d67b3fbdf59b84cc83ac34f3e5.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/7d82143fe9c0beb9e038ea68b2e98957.jfif',
      description: '冷蔵庫を動かさずに、裏側のシミや黒ずみをきれいにリメイク。家具の配置を変えずに施工完了。',
      workTime: '2時間45分',
      cost: '32,000円',
      area: '22㎡'
    },
    {
      id: 11,
      category: '冷蔵庫裏',
      title: '洗濯機裏の湿気による汚れ除去',
      location: 'さいたま市浦和区 1K アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/6a9c2d503d3f7f05ea12fc4bf4675159.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/27f67e53dd04b89476d012dae839ad86.jfif',
      description: '洗濯機裏の湿気とホコリによる汚れを、家電を動かすことなく専用ツールでクロスメイク施工。',
      workTime: '2時間30分',
      cost: '28,000円',
      area: '18㎡'
    },
    {
      id: 12,
      category: '冷蔵庫裏',
      title: '電子レンジ台裏の油汚れ除去',
      location: 'さいたま市北区 1R アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/2d0b5d23cedb04d0826c7ad387d517d0.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/ff6f070779eb3e559bad9ca9d0906acc.jfif',
      description: '電子レンジ台裏に飛び散った調理油による汚れを、家電を移動せずに特殊洗浄とクロスメイクで除去。',
      workTime: '2時間',
      cost: '24,000円',
      area: '14㎡'
    },
    {
      id: 13,
      category: '手垢・汚れ',
      title: '日常生活による手垢や汚れの除去',
      location: 'さいたま市桜区 2DK アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/8d9303e862c907034f637786287e7f19.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/27c5b35d6a18feb70fe40471669195a6.jfif',
      description: 'スイッチ周りや扉付近の手垢、子供の落書きなど日常生活による汚れを完全に除去し、新品同様に再生。',
      workTime: '4時間',
      cost: '45,000円',
      area: '35㎡'
    },
    {
      id: 14,
      category: '手垢・汚れ',
      title: 'コンセント周りの汚れ除去',
      location: 'さいたま市南区 1K マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/2cef8a541f036f799490f2a0d4bb013c.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/26391431238c1975606bdee247f44231.jfif',
      description: '電気スイッチ周りに蓄積した手垢や汚れを、丁寧な前処理とクロスメイクで新品同様の白さに再生。',
      workTime: '2時間30分',
      cost: '28,000円',
      area: '18㎡'
    },
    {
      id: 15,
      category: '手垢・汚れ',
      title: '換気フード周りの黒ずみ汚れ除去',
      location: 'さいたま市大宮区 1DK アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/4d45c21b92c9701455cc929fdc7e1ba2.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/0ce7b46bde9d67fa2f7e141d267e2a1b.jfif',
      description: '換気扇フードまわりの黒ずみを、特殊洗浄とクロスメイクで完全に除去し、清潔な印象に。',
      workTime: '3時間',
      cost: '32,000円',
      area: '21㎡'
    }
  ];

  const categories = [
    { value: 'all', label: 'すべて' },
    { value: 'ヤニ汚れ', label: 'ヤニ汚れ' },
    { value: 'カビ汚れ', label: 'カビ汚れ' },
    { value: '換気扇・換気口', label: '換気扇・換気口' },
    { value: '冷蔵庫裏', label: '冷蔵庫裏' },
    { value: '手垢・汚れ', label: '手垢・汚れ' }
  ];

  const filteredCases = selectedCategory === 'all' 
    ? caseStudies 
    : caseStudies.filter(study => study.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-4">
              <div className="text-2xl font-bold text-teal-600" style={{ fontFamily: 'Pacifico, serif' }}>
                クロスメイク浦和
              </div>
              <div className="text-lg font-bold text-navy-800 bg-teal-50 px-4 py-2 rounded-lg">
                オーナー様の味方
              </div>
            </Link>
            <nav className="hidden md:flex space-x-6">
              <Link to="/#service" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                サービス内容
              </Link>
              <Link to="/#case-studies" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                施工事例
              </Link>
              <Link to="/#pricing" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                料金
              </Link>
              <Link to="/#faq" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                よくある質問
              </Link>
              <Link to="/#company" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                会社概要
              </Link>
            </nav>
            <div className="flex items-center space-x-4">
              <a href="https://lin.ee/g0Jj95Y" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" 
                  alt="友だち追加" 
                  height="36" 
                  className="cursor-pointer hover:opacity-80 transition-opacity"
                />
              </a>
              <div className="text-sm text-gray-600">TEL: 048-614-1544</div>
            </div>
          </div>
        </div>
      </header>

      {/* パンくずリスト */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-teal-600 hover:text-teal-700 cursor-pointer">
              ホーム
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-600">壁紙張替え・クロス交換不要の施工事例一覧</span>
          </nav>
        </div>
      </div>

      {/* ヒーローセクション */}
      <section className="py-16 bg-gradient-to-r from-teal-50 to-blue-50">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            壁紙張替え・クロス交換不要の施工事例一覧
          </h1>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-4">
            壁紙交換やクロス張替えをせずに新品同様に再生するクロスメイクの実際の施工事例をビフォーアフター写真でご確認ください。<br />
            退去費用を約半額に削減し、どんなクロス汚れでも壁紙張替え不要で対応できることがお分かりいただけます。
          </p>
          <div className="text-lg text-gray-700 bg-white/80 inline-block px-6 py-3 rounded-lg">
            <strong>クロス部分張替えや全面クロス工事の代替案として注目の技術</strong>
          </div>
        </div>
      </section>

      {/* SEO強化セクション */}
      <section className="py-12 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div className="bg-teal-50 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-800 mb-3">壁紙張替え不要の革新技術</h2>
                <p className="text-gray-600">
                  従来の壁紙交換やクロス張替えとは異なり、既存の壁紙を活かしたクロスメイクで退去費用を大幅削減
                </p>
              </div>
              <div className="bg-orange-50 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-800 mb-3">クロス汚れ完全対応</h2>
                <p className="text-gray-600">
                  ヤニ、カビ、手垢など様々なクロス汚れに対応。クロス部分張替えよりも効率的で経済的
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-800 mb-3">クロス工事の新基準</h2>
                <p className="text-gray-600">
                  短時間施工で空室期間短縮。従来のクロス交換工事に代わる次世代の原状回復方法
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* フィルター */}
      <section className="py-8 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.value}
                onClick={() => setSelectedCategory(category.value)}
                className={`px-6 py-3 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  selectedCategory === category.value
                    ? 'bg-teal-600 text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* 施工事例一覧 */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              壁紙張替え・クロス交換不要の実績事例
            </h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              退去費用削減を実現したクロス汚れ対応事例をカテゴリー別にご紹介。<br />
              壁紙交換やクロス部分張替えと比較して、コストと時間を大幅に短縮した実績をご確認ください。
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredCases.map((caseStudy) => (
              <div key={caseStudy.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="relative">
                  <div className="grid grid-cols-2">
                    <div className="relative">
                      <img
                        src={caseStudy.before}
                        alt={`${caseStudy.title} - 壁紙張替え前のクロス汚れ状態`}
                        className="w-full h-48 object-cover"
                      />
                      <div className="absolute top-2 left-2 bg-red-500 text-white px-2 py-1 rounded text-sm font-semibold">
                        クロス交換前
                      </div>
                    </div>
                    <div className="relative">
                      <img
                        src={caseStudy.after}
                        alt={`${caseStudy.title} - 壁紙張替え不要で再生後`}
                        className="w-full h-48 object-cover"
                      />
                      <div className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-sm font-semibold">
                        クロス工事後
                      </div>
                    </div>
                  </div>
                  <div className="absolute top-2 right-2 bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {caseStudy.category}
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-2">
                    {caseStudy.title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-sm">
                    {caseStudy.location}
                  </p>
                  <p className="text-gray-700 mb-4 leading-relaxed">
                    {caseStudy.description}
                  </p>

                  <div className="grid grid-cols-3 gap-4 mb-4">
                    <div className="text-center">
                      <div className="text-sm text-gray-500">施工時間</div>
                      <div className="font-semibold text-gray-800">{caseStudy.workTime}</div>
                    </div>
                    <div className="text-center">
                      <div className="text-sm text-gray-500">退去費用</div>
                      <div className="font-semibold text-teal-600">{caseStudy.cost}</div>
                    </div>
                    <div className="text-center">
                      <div className="text-sm text-gray-500">面積</div>
                      <div className="font-semibold text-gray-800">{caseStudy.area}</div>
                    </div>
                  </div>

                  <Link
                    to={`/case-detail/${caseStudy.id}`}
                    className="block w-full bg-teal-600 hover:bg-teal-700 text-white text-center py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    詳細を見る
                  </Link>

                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA セクション */}
      <section className="py-16 bg-teal-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">
            あなたの物件も壁紙張替え不要で同じように再生できます
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto">
            どんなクロス汚れでも、壁紙交換やクロス部分張替えをせずに新品同様に再生可能です。<br />
            退去費用を約半額に削減するクロス工事の新基準をぜひお試しください。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/#estimate-form"
              className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              作業依頼する
            </Link>
            <a
              href="tel:048-614-1544"
              className="bg-white hover:bg-gray-50 text-gray-800 px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap border border-gray-200"
            >
              電話で相談する
            </a>
          </div>

          {/* お得なクーポン案内 */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-lg font-semibold text-gray-800 mb-4">
              お得なクーポンはこちら
            </p>
            <a href="https://lin.ee/g0Jj95Y" target="_blank" rel="noopener noreferrer">
              <img 
                src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" 
                alt="友だち追加でお得なクーポンをゲット" 
                height="36" 
                className="cursor-pointer hover:opacity-80 transition-opacity mx-auto"
              />
            </a>
            <p className="text-sm text-gray-600 mt-2">
              LINE友だち追加でお得なクーポンをプレゼント！
            </p>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div
                className="text-2xl font-bold text-teal-400 mb-4"
                style={{ fontFamily: 'Pacifico, serif' }}
              >
                壁紙革命浦和
              </div>
              <p className="text-gray-300 mb-4">
                39raリフォーム有限会社　サクラリフォーム<br />
                代表：瀬下尊由希<br />
                TEL: 048-614-1544
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">サービス一覧</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <Link to="/#service" className="hover:text-teal-400 cursor-pointer transition-colors">
                    クロスメイク
                  </Link>
                </li>
                <li>
                  <Link to="/before-after" className="hover:text-teal-400 cursor-pointer transition-colors">
                    施工事例
                  </Link>
                </li>
                <li>
                  <Link to="/#pricing" className="hover:text-teal-400 cursor-pointer transition-colors">
                    料金案内
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
              <div className="space-y-2 text-gray-300">
                <div className="flex items-center">
                  <i className="ri-phone-line mr-2 text-teal-400"></i>
                  <span>048-614-1544</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line mr-2 text-teal-400"></i>
                  <span>平日・土曜 9:00-18:00</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>
              © 2024 39raリフォーム有限会社　サクラリフォーム. All rights reserved.
              <span className="mx-2">|</span>
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-teal-400 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
